import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import {Space, Tooltip} from 'antd';
import {StyledNameWithLink} from './StyledNameWithLink';
import {ExternalLinkIcon} from '../../icons';

const NameWithLink = ({
  color,
  linkIconTooltip,
  name,
  onClick,
  target = '_blank',
  tooltip,
  url,
  variant = 'system',
  ...rest
}) => {

  const getLink = () => {
    if (onClick) {
      const linkText = (
        <span
          className='pointer'
          role='button'
          onClick={(e) => { e.stopPropagation(); onClick(e); }}
        >
          <ExternalLinkIcon />
        </span>
      );
      if (linkIconTooltip) {
        return <Tooltip title={linkIconTooltip}>{linkText}</Tooltip>;
      }
      return linkText;
    }

    if (!url) return null;

    if (variant === 'text') {
      return <ExternalLinkIcon />;
    }

    const LinkComponent = variant === 'system' ? Link : 'a';
    const linkProps = variant === 'system' ? { to: url } : { href: url };
    const rel = target === '_blank' ? 'noopener noreferrer' : undefined;

    return (
      <LinkComponent {...linkProps} target={target} rel={rel} onClick={(e) => e.stopPropagation()}>
        <ExternalLinkIcon />
      </LinkComponent>
    );
  };

  const linkElement = getLink();

  const content = (
    <StyledNameWithLink color={color} {...rest}>
      <Space align='center' size='small' className='d-flex-child'>
        {name && <span>{name}</span>}
        {linkElement}
      </Space>
    </StyledNameWithLink>
  );

  if (tooltip) {
    return <Tooltip title={tooltip}>{content}</Tooltip>;
  }

  return content;
}

NameWithLink.propTypes = {
  color: PropTypes.string,
  linkIconTooltip: PropTypes.node,
  name: PropTypes.string,
  onClick: PropTypes.func,
  target: PropTypes.string,
  tooltip: PropTypes.node,
  url: PropTypes.string,
  variant: PropTypes.oneOf(['system', 'remote', 'text']),
}

export default NameWithLink;

